import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './Table.scss';
import { Props } from './interfaces';
import './Table-media.scss';

const Table = ({ data, headDark, headLight, title = '', themeLight, perc50 = false }: Props) => {
  return (
    <>
      {title ? <h2 className="table__title">{title}</h2> : null}
      <div className={`table${themeLight ? ' table_light' : ''}`}>
        <table className="">
          {headDark}
          {headLight}
          {data.map((row, i) => (
            <tr key={i}>
              {row.map((item, idx) => (
                <td
                  key={idx}
                  dangerouslySetInnerHTML={{ __html: item }}
                  className={perc50 ? 'table__50' : ''}
                ></td>
              ))}
            </tr>
          ))}
        </table>
      </div>
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(Table));
